import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_OL_ANNULLAMENTO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolAnnullatoState extends EntityState<IID_OL_ANNULLAMENTO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_ANNULLATO })
@InterfaceDataStore(InterfaceName.ANNULLATO)
export class IIDolAnnullatoStore extends EntityStore<IIDolAnnullatoState> {
  constructor() {
    super([]);
  }
}
